module.exports = __webpack_public_path__ + "static/media/bfile-ira.24fac37f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-ira.svg
// module id = 250
// module chunks = 0